import digitalData from 'digital-data';
import { getState, setState } from '../analytics-state';

export const carPicker = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.dropdown-item-click', ({ output }) => {
    const {
      year, yearIndex, make, makeIndex, model, modelIndex
    } = output || {};

    const { currentPage, pageType, sortBy } = getState();

    let {
      data,
      formattedIndexes,
      formattedYearMakeModel,
      formattedYearMakeModelAlt
    } = getState()?.automotive || {};

    if (year) {
      data = {
        ...data,
        make: '',
        makeIndex: 'default',
        model: '',
        modelIndex: 'default'
      };
    }

    if (make) {
      data = {
        ...data,
        model: '',
        modelIndex: 'default'
      };
    }

    data = {
      ...data,
      ...(year && { year: year.value, yearIndex }),
      ...(make && { make: make.value, makeIndex }),
      ...(model && { model: model.value, modelIndex }),
    };

    formattedYearMakeModel = (
      `${data.year || ''} ${data.make || ''} ${data.model || ''}`
    ).trim();

    formattedYearMakeModelAlt = (
      `${data.year ? data.year : ''}${data.make ? '>' + data.make : ''}${data.model ? '>' + data.model : ''}`
    );

    formattedIndexes = (
      `${(data.yearIndex || data.yearIndex === 0) && data.yearIndex}:`
      + `${(data.makeIndex || data.yearIndex === 0) && data.makeIndex}:`
      + `${(data.modelIndex || data.yearIndex === 0) && data.modelIndex}`
    );

    setState({
      automotive:
      {
        data,
        formattedIndexes,
        formattedYearMakeModel,
        formattedYearMakeModelAlt
      }
    });

    const ddoEvent = {
      eventInfo: {
        eventName: 'filter by'
      },
      category: {
        primaryCategory: pageType,
      },
      filter: [{
        selectionMethod: 'default',
        type: 'vehicle',
        value: formattedYearMakeModel,
        position: formattedIndexes
      }],
      displayAttributes: {
        viewType: 'grid',
        pageNumber: currentPage,
        productsAvailability: 'all products',
        sortBy
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.select-vehicle-click', () => {

    const { formattedYearMakeModelAlt } = getState()?.automotive;

    const ddoEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'widget interaction'
      },
      eventMode: 'stash',
      content: {
        widget: {
          type: 'auto',
          value: formattedYearMakeModelAlt
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.shop-universal-parts', () => {

    const { currentPage, pageType, sortBy } = getState();
    const { formattedIndexes } = getState()?.automotive;

    const ddoEvent = {
      eventInfo: {
        eventName: 'filter by'
      },
      category: {
        primaryCategory: pageType,
      },
      filter: [{
        selectionMethod: 'default',
        type: 'automotive fit type',
        value: 'universal',
        position: formattedIndexes
      }],
      displayAttributes: {
        viewType: 'grid',
        pageNumber: currentPage,
        productsAvailability: 'all products',
        sortBy
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('car-picker.dont-see-vehicle', () => {

    const { formattedYearMakeModelAlt } = getState()?.automotive;

    const ddoEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'widget interaction'
      },
      eventMode: 'stash',
      content: {
        widget: {
          type: 'auto',
          value: formattedYearMakeModelAlt || 'no selection'
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};